export const MIN_CREDITS_FOR_JOB_START = parseFloat(process.env.VUE_APP_MIN_CREDITS_FOR_JOB_START ?? '0.1')

export const ALLOW_CREDITS_OVERUSE = '__allow_credits_overuse'

export const TERMS = {
  INSUFFICIENT_CREDS_TITLE: 'Insufficient funds',
  INSUFFICIENT_CREDS_BODY: `New jobs may only be created with a HQ$ balance higher than <strong>${MIN_CREDITS_FOR_JOB_START}</strong>. Top up your HQ$ balance to proceed.`
};
